/**
 * @typedef {Object} Params
 * @property {number} maxLength
 * @property {number} minLength
 * @property {string} value
 */

/**
 * * @param {Object} Params
 * @returns {boolean}
 */

const isSearchValueValid = ({ maxLength, minLength, value }) => {
    const trimmedValueLength = (value || '').trim().length;
    const isValid =
        !!trimmedValueLength &&
        minLength <= trimmedValueLength &&
        trimmedValueLength < maxLength;

    return isValid;
};

export default isSearchValueValid;
